module.exports = __webpack_public_path__ + "static/media/back-arrow-icon.614e4e2d.svg";